import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-external-link",
  "use": "arrow-external-link-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-external-link\"><path d=\"M9.483 1a.336.336 0 00-.237.573l1.8 1.8-4.63 4.629a1.118 1.118 0 001.582 1.582l4.63-4.63 1.8 1.8A.336.336 0 0015 6.517V1.336A.336.336 0 0014.665 1H9.482z\" /><path d=\"M5 1.5a.5.5 0 00-.5-.5H2a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1v-2.5a.5.5 0 00-1 0V14H2V2h2.5a.5.5 0 00.5-.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol